import React from 'react'

const MatchMakerQuestionContainer = ({ imagePath, title, description }) => (
  <div className=''>
    <img src={imagePath} />
    <div className='question'>
      <p className='title'>{title}</p>
      <p className='description'>{description}</p>
    </div>
  </div>
)

export { MatchMakerQuestionContainer }
